export default defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserStore()
  const { createBackTo } = useBackTo()

  if (userStore.isAuthorized) {
    return
  }

  const authRouteNames = ['login', 'signup']
  const isProtectedRoute = to.meta.auth || to.path.includes('/account/')

  if (isProtectedRoute) {
    return navigateTo({
      name: 'login',
      query: {
        backTo: createBackTo(to.fullPath),
      },
    })
  }

  const toName = typeof to.name === 'string' ? to.name : ''
  const fromName = typeof from.name === 'string' ? from.name : ''

  if (!authRouteNames.includes(toName) || to.query.backTo) {
    return
  }

  const carriedBackTo = from.query.backTo
  if (authRouteNames.includes(fromName) && typeof carriedBackTo === 'string' && carriedBackTo) {
    return navigateTo({
      name: toName,
      query: {
        backTo: carriedBackTo,
      },
    })
  }

  const exceptionNames = [...authRouteNames, 'index']
  if (fromName && !exceptionNames.includes(fromName)) {
    return navigateTo({
      name: toName,
      query: {
        backTo: createBackTo(from.fullPath),
      },
    })
  }
})
